package pl.michal_cyran.brand_hub.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRight
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.BtnLgStyle
import pl.michal_cyran.brand_hub.BtnPrimaryStyle
import pl.michal_cyran.brand_hub.BtnStyle

@Composable
fun PrimaryButton(
    path: String,
    text: String,
    icon: @Composable () -> Unit,
) {
    Link(
        path = path,
        modifier = BtnStyle.toModifier()
            .then(BtnPrimaryStyle.toModifier())
            .then(BtnLgStyle.toModifier())
    ) {
        Text(text)
        icon()
    }
}